import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './icons/Icons';
export const About = () => {
  const credentials = ['Esthetician Certificada', 'Medical Assistant', 'Skincare Specialist', 'Acne Specialist', 'Laser Certified', 'PRP Trained'];
  return <section id="sobre-mi" className="py-12 md:py-16 bg-brand-cream relative overflow-hidden" data-id="element-15">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-sand rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-16"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-blush rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 translate-y-1/2" data-id="element-17"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-18">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-19">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-5/12" data-id="element-20">
            <div className="relative" data-id="element-21">
              {/* Elegant Frame */}
              <div className="absolute -inset-4 border border-brand-gold/40 rounded-t-full rounded-b-3xl" data-id="element-22"></div>
              <div className="absolute -inset-2 border border-brand-gold/20 rounded-t-full rounded-b-2xl" data-id="element-23"></div>

              <div className="relative rounded-t-full rounded-b-xl overflow-hidden shadow-2xl aspect-[3/4]" data-id="element-24">
                <img src="https://cdn.magicpatterns.com/uploads/npYAe1XU8hoXahmQFhCmf3/maria_fernanda_2.png" alt="María Fernanda Salcedo" className="w-full h-full object-cover object-center" data-id="element-25" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/40 to-transparent" data-id="element-26"></div>
              </div>

              {/* Corner Ornament */}
              <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b-2 border-r-2 border-brand-gold rounded-br-3xl opacity-50" data-id="element-27"></div>
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-7/12" data-id="element-28">
            <div className="mb-4 flex items-center space-x-4" data-id="element-29">
              <div className="h-px w-12 bg-brand-gold" data-id="element-30"></div>
              <span className="text-brand-bronze tracking-widest uppercase text-sm font-medium" data-id="element-31">
                Conóceme
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-32">
              María Fernanda
            </h2>
            <p className="text-xl text-brand-gold font-serif italic mb-8" data-id="element-33">
              La persona detrás de cada tratamiento
            </p>

            <div className="space-y-6 text-brand-charcoal/80 leading-relaxed mb-10" data-id="element-34">
              <p data-id="element-35">
                Mi nombre es María Fernanda Salcedo y hace 3 años comencé este
                sueño en el mundo de la belleza como Esthetician y Medical
                Assistant.
              </p>
              <p data-id="element-36">
                Lo que nunca imaginé que se convertiría en mi pasión, hoy es una
                de las cosas que más amo hacer. Siempre me ha gustado el cuidado
                personal — verme bien, sentirme bien, y sobre todo, ayudar a
                otros a sentirse seguros y felices consigo mismos.
              </p>
              <p data-id="element-37">
                Soy detallista con cada tratamiento que realizo, porque para mí
                no se trata solo de belleza.{' '}
                <span className="font-medium text-brand-charcoal" data-id="element-38">
                  Se trata de hacerte sentir bien desde adentro.
                </span>
              </p>
              <p data-id="element-39">
                En Skin Glow Studio 22 creé un espacio pensado para consentirte,
                relajarte y resaltar tu belleza natural — con amor, cuidado y el
                profesionalismo que tú mereces. Cada cliente que entra a mi
                studio es especial. Cada piel tiene su historia. Y mi trabajo es
                leerla, entenderla y transformarla.
              </p>
            </div>

            <blockquote className="border-l-2 border-brand-gold pl-6 py-2 mb-12" data-id="element-40">
              <p className="text-2xl font-serif italic text-brand-charcoal leading-snug" data-id="element-41">
                "Mi meta es que salgas de aquí sintiéndote diferente. No solo
                viéndote diferente — sintiéndote diferente."
              </p>
              <footer className="mt-4 text-sm font-medium text-brand-bronze uppercase tracking-wider" data-id="element-42">
                — María Fernanda Salcedo, CEO & Founder
              </footer>
            </blockquote>

            {/* Credentials Grid */}
            <div className="flex flex-wrap gap-3" data-id="element-43">
              {credentials.map((cred, index) => <div key={index} className="flex items-center space-x-2 bg-brand-blush border border-brand-gold/20 px-4 py-2 rounded-full shadow-sm" data-id="element-44">
                  <div className="text-brand-gold" data-id="element-45">
                    <CheckIcon size={16} data-id="element-46" />
                  </div>
                  <span className="text-sm font-medium text-brand-charcoal" data-id="element-47">
                    {cred}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};